/**
 * Contact details, taken from the sibling corporate site at
 * `apps/oneasia-corp`, which is the same company:
 *
 *   phone   — the office number in its footer (`Footer.tsx`)
 *   email   — the address its own "get in touch" CTA points at (`Vending.tsx`)
 *   website — inferred, not quoted: oneasia-corp publishes no marketing URL,
 *             but both company addresses (info@ and the support@ on this
 *             site's login page) are on statas.io. Confirm before print.
 *
 * STACKCOMBO is a Summerlin Co., Ltd. company; oneasia-corp also carries a
 * registered address at 1 Empire Tower, 47th Fl., South Sathorn Road,
 * Yannawa, Sathorn, Bangkok 10120, Thailand, if the footer ever needs it.
 */
export const CONTACT = {
  phone: '+662 119 8474',
  email: 'info@statas.io',
  website: 'statas.io',
} as const;
